import { DOCUMENT } from '@angular/common';
import { Directive, inject } from '@angular/core';
import { IS_MICROFRONTEND, OVERLAY_ROOT_TOKEN } from '@client/mfe/tokens/mfe-tokens';

const createTooltipDocument = (): Document => {
    const document = inject(DOCUMENT, { skipSelf: true });
    const isMicrofrontend = inject(IS_MICROFRONTEND, { optional: true });
    const overlayRoot = inject(OVERLAY_ROOT_TOKEN, { optional: true });

    if (!isMicrofrontend || !overlayRoot) {
        return document;
    }

    return new Proxy(document, {
        get (target: Document, property: string | symbol): unknown {
            if (property === 'body') {
                return overlayRoot;
            }

            if (property === 'querySelector') {
                return (selector: string): Element | null => {
                    if (selector === 'body') {
                        return overlayRoot;
                    }

                    return target.querySelector(selector);
                };
            }

            const value = Reflect.get(target, property);

            return typeof value === 'function' ? value.bind(target) : value;
        },
    }) as Document;
};

@Directive({
    selector: '[ngbTooltip]',
    standalone: true,
    providers: [
        {
            provide: DOCUMENT,
            useFactory: createTooltipDocument,
        },
    ],
})
export class NgbTooltipMfeDocumentDirective {}
